define('responsive-gameday/views/render/LineupViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/lineup/lineup','Wax/get!view-templates/lineup/batting'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function LineupViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/lineup/lineup'),{
                battingView : require( 'Wax/get!view-templates/lineup/batting' )
            }
        );
    }
    ViewRender.spawn(LineupViewRender);

    Superclass=LineupViewRender.superclass;

    return LineupViewRender;
});
